import { LEGAL_DOC_URL } from '@oy/types';
import { Loader } from '@oy/uidesktop';
import { useContext, useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { getLegalDocumentById } from 'src/clients';
import useSWR from 'swr';
import { SignLegalDocumentModalContext } from '../../useSignLegalDocumentModalContext';
import styles from './PreviewDocument.module.css';

pdfjs.GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.js';

export const PreviewDocument = () => {
  const [numPages, setNumPages] = useState(0);

  const [width, setWidth] = useState(0);
  const onLoadSuccess = (newNumPages: number) => {
    setNumPages(newNumPages);
  };
  const { selectedDocument, setRef } = useContext(
    SignLegalDocumentModalContext,
  );
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  const { data, isLoading, isValidating } = useSWR(
    selectedDocument ? [LEGAL_DOC_URL, selectedDocument] : null,
    () =>
      getLegalDocumentById(selectedDocument ?? '').then(
        data => data.data.data?.file,
      ),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
    },
  );

  const currentFile = data ? `data:application/pdf;base64,${data}` : null;

  return (
    <div ref={containerRef} className={styles.container}>
      <div ref={setRef} className={styles.pdfReaderContainer}>
        {isLoading || isValidating ? (
          <Loader />
        ) : (
          // @ts-ignore
          <Document
            file={currentFile}
            onLoadSuccess={({ numPages }) => onLoadSuccess(numPages)}
            className={styles.document}
          >
            {Array.from(new Array(numPages), (_, index) => (
              // @ts-ignore
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={width}
              />
            ))}
          </Document>
        )}
      </div>
    </div>
  );
};
